import { reactive, ref, computed, onMounted, onUnmounted } from '@vue/composition-api'
import * as _ from 'lodash'
import { PRODUCT_STATUS } from '@/util/constants'

export const ContractAssignLicenseTable = (context) => {
  const store = context.root.$store
  store.dispatch('contractPack/getPackageData')
  store.dispatch('users/getUsersData')

  const state = reactive({
    products: computed(() => store.getters['contractPack/signedPackageProductForTable']),
    users: computed(() => {
      const users = store.getters['users/sortedLoginIdAndAuth']
      return _.map(users, user => {
        return {
          name: user.name,
          products: _.map(user.products, product => product.code)
        }
      })
    }),
    isActive: (product, user) => _.includes(user.products, product.code)
  })
  const scrollableHeight = ref(0)
  const scrollableWidth = ref(0)
  function onResize() {
    scrollableHeight.value = window.innerHeight - context.refs.areaScrollable.getBoundingClientRect().top
    scrollableWidth.value = window.innerWidth
  }
  onMounted(() => {
    scrollableHeight.value = window.innerHeight - context.refs.areaScrollable.getBoundingClientRect().top
    scrollableWidth.value = window.innerWidth
    window.addEventListener('resize', onResize)
    context.root.targetScrollFlg = true
  })

  onUnmounted(() => {
    window.removeEventListener('resize', onResize)
  })

  return {
    state,
    PRODUCT_STATUS,
    scrollableHeight,
    scrollableWidth,
    onResize
  }
}
